'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var errcode = require('err-code');

var _require = require('uint8arrays/concat'),
    uint8ArrayConcat = _require.concat;

var _require2 = require('uint8arrays/from-string'),
    uint8ArrayFromString = _require2.fromString;

var hmac = require('../hmac');

var cipherMap = {
  'AES-128': {
    ivSize: 16,
    keySize: 16
  },
  'AES-256': {
    ivSize: 16,
    keySize: 32
  },
  Blowfish: {
    ivSize: 8,
    cipherKeySize: 32
  }
}; // Generates a set of keys for each party by stretching the shared key.
// (myIV, theirIV, myCipherKey, theirCipherKey, myMACKey, theirMACKey)

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cipherType, hash, secret) {
    var cipher, allowed, cipherKeySize, ivSize, hmacKeySize, seed, resultLength, m, a, result, j, b, todo, half, resultBuffer, r1, r2, createKey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cipher = cipherMap[cipherType];

            if (cipher) {
              _context.next = 4;
              break;
            }

            allowed = Object.keys(cipherMap).join(' / ');
            throw errcode(new Error("unknown cipher type '".concat(cipherType, "'. Must be ").concat(allowed)), 'ERR_INVALID_CIPHER_TYPE');

          case 4:
            if (hash) {
              _context.next = 6;
              break;
            }

            throw errcode(new Error('missing hash type'), 'ERR_MISSING_HASH_TYPE');

          case 6:
            cipherKeySize = cipher.keySize;
            ivSize = cipher.ivSize;
            hmacKeySize = 20;
            seed = uint8ArrayFromString('key expansion');
            resultLength = 2 * (ivSize + cipherKeySize + hmacKeySize);
            _context.next = 13;
            return hmac.create(hash, secret);

          case 13:
            m = _context.sent;
            _context.next = 16;
            return m.digest(seed);

          case 16:
            a = _context.sent;
            result = [];
            j = 0;

          case 19:
            if (!(j < resultLength)) {
              _context.next = 32;
              break;
            }

            _context.next = 22;
            return m.digest(uint8ArrayConcat([a, seed]));

          case 22:
            b = _context.sent;
            todo = b.length;

            if (j + todo > resultLength) {
              todo = resultLength - j;
            }

            result.push(b);
            j += todo;
            _context.next = 29;
            return m.digest(a);

          case 29:
            a = _context.sent;
            _context.next = 19;
            break;

          case 32:
            half = resultLength / 2;
            resultBuffer = uint8ArrayConcat(result);
            r1 = resultBuffer.slice(0, half);
            r2 = resultBuffer.slice(half, resultLength);

            createKey = function createKey(res) {
              return {
                iv: res.slice(0, ivSize),
                cipherKey: res.slice(ivSize, ivSize + cipherKeySize),
                macKey: res.slice(ivSize + cipherKeySize)
              };
            };

            return _context.abrupt("return", {
              k1: createKey(r1),
              k2: createKey(r2)
            });

          case 38:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();